var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_19_15",
    "data-name": "Component 19 \\u2013 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 63,
    viewBox: "0 0 129 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    fill: "none",
    stroke: "#5aa5ef",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 63,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 127,
    height: 61,
    rx: 9,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Movie_Info",
    "data-name": "Movie Info",
    transform: "translate(-64 107.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2019_-_Drama_-_120_m",
    "data-name": "2019 - Drama - 120 m",
    transform: "translate(109 -70.5)",
    fill: "#020410",
    fontSize: 16,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Save")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveButton);
export default __webpack_public_path__ + "static/media/saveButton.3807e9c081cb769c7d920e1247a28be2.svg";
export { ForwardRef as ReactComponent };